<template>
  <div class="reset-password" />
</template>

<script>
import { getCookie, removeCookie } from '@/utils/js-cookie';

export default {
  computed: {
    isLogin() {
      return getCookie('user_access_token');
    },
  },
  created() {
    if (this.isLogin) {
      removeCookie('user_access_token');
      sessionStorage.removeItem('userInformation');
      sessionStorage.removeItem('userType');
      sessionStorage.removeItem('customerInformation');
      sessionStorage.removeItem('mailpwpopupopen');
    }
  },
  mounted() {
    this.$store.dispatch('user/checkPasswordRecoveryToken', {
      token: this.$route.params.token,
      secret: this.$route.params.secret,
    })
      .then((res) => {
        if (res.status === 204) {
          this.$store.dispatch('user/showResetPasswordDialog');
        }
      })
      .catch((err) => {
        if (err.response.status === 412) {
          this.$store.dispatch('dialog/setShowErrorDialog', {
            status: true,
            title: this.$t('langkey.token-expired'),
            message: this.$t('langkey.password-token-expired-msg'),
          })
            .then(() => {
              this.$router.push(this.$i18nRoute({
                name: 'login',
              }));
            });
        } else if (err.response.status === 404) {
          this.$store.dispatch('dialog/setShowErrorDialog', {
            status: true,
            title: this.$t('langkey.token-unknown'),
            message: this.$t('langkey.password-token-unknown-msg'),
          })
            .then(() => {
              this.$router.push(this.$i18nRoute({
                name: 'login',
              }));
            });
        }
      });
  },
};
</script>